import styled from 'styled-components'
import { theme } from '../../../styles/theme';

export const ImportModalTitle = styled.h2`
  width: 100%;
  margin: 0 0 20px;
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 22px;
  font-weight: 800;
  color: ${theme.colors.gray.Cinza_2};
`;

export const ImportTabs = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 20px;

  @media only screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ImportTabCard = styled.button`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  cursor: pointer;
  padding: 14px 16px;
  border-radius: 12px;
  background: ${props => props.active ? theme.colors.green.Fundo : theme.colors.white.Branco};
  border: 1.5px solid ${props => props.active ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_11};
  color: ${theme.colors.gray.Cinza_2};
  transition: border-color .15s, background .15s;

  b {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 800;
  }

  span {
    font-size: 12px;
    color: ${theme.colors.gray.Cinza_6};
  }
`;

export const ImportStepsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export const ImportStepItem = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  text-align: left;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${theme.colors.gray.Cinza_6};

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: ${theme.colors.green.Verde_AgroReceita};
  }

  b {
    color: ${theme.colors.gray.Cinza_2};
  }
`;

export const ImportFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid ${theme.colors.gray.Cinza_11};

  @media only screen and (max-width: 640px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

export const ImportFooterNote = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  max-width: 340px;
  font-size: 12px;
  color: ${theme.colors.gray.Cinza_6};

  @media only screen and (max-width: 640px) {
    max-width: none;
    text-align: center;
  }
`;

export const ImportFooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media only screen and (max-width: 640px) {
    > * {
      flex: 1;
    }
  }
`;

export const ImportChecklistLabel = styled.div`
  width: 100%;
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${theme.colors.gray.Cinza_6};
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const ImportDataHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ImportDataModalTitle = styled.h2`
  margin: 0;
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 22px;
  font-weight: 800;
  color: ${theme.colors.gray.Cinza_2};
`;

export const ImportDataCloseButton = styled.button`
  all: unset;

  width: 32px;
  height: 32px;
  min-width: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: ${theme.colors.gray.Cinza_12};
  cursor: pointer;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const ImportDataTabs = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${theme.colors.gray.Cinza_11};
`;

export const ImportDataTabsDivider = styled.div`
  width: 1px;
  align-self: center;
  height: 34px;

  background: ${theme.colors.gray.Cinza_11};
`;

export const ImportDataSectionLabel = styled.p`
  width: 100%;
  margin: 12px 0;
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${theme.colors.gray.Cinza_6};
`;

export const ImportDataSteps = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
`;

export const ImportDataStep = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const ImportDataStepNumber = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: ${theme.colors.gray.Cinza_2};
  color: ${theme.colors.white.Branco};
  font-size: 11px;
  font-weight: 800;
`;

export const ImportDataStepText = styled.div`
  padding-top: 1px;
  text-align: left;
  font-size: 13px;
  line-height: 1.5;
  color: ${theme.colors.gray.Cinza_2};
`;

export const ImportDataAttentionBox = styled.div`
  margin: 8px 0 0 30px;
  padding: 10px 14px;

  background: ${theme.colors.gray.Cinza_13};
  border-left: 3px solid ${theme.colors.orange.Laranja_Sudeste};
  border-radius: 4px;

  text-align: left;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${theme.colors.gray.Cinza_6};

  b {
    color: ${theme.colors.gray.Cinza_2};
  }
`;

export const Container = styled.div`
    width: 100%;
    height: auto;

    gap: 1.5rem;
    display: flex;
    flex-direction: column;
`

export const Wrapper = styled.div`
    width: 100%;
    height: auto;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media (max-width: 479px) {
      gap: 1rem;
    }
`;

export const LayoutArea = styled.div`
    width: 100%;
    height: auto;
    max-width: 64.75rem;

    position: relative;

    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ContainerLoading = styled.div`
  width: 100%;
  min-height: 320px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContainerMobileButtonAndInput = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    >div{
      width: 80%;
    }

    @media (max-width: 760px) {
      gap: 0.5rem;
      flex-wrap: wrap;
    }
`;

export const ContainerInputAndButton = styled.div`
    width: 100%;
    height: auto;
    max-width: 64.75rem;

    gap: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    @media (max-width: 479px) {
      >div:nth-of-type(2){
        width: calc(100% - 138px);
      }
    }
`

export const ContainerButtonView = styled.button`
  all: unset;

  width: auto;
  height: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  >img{
    width: 35px;
    height: auto;
  }
`

export const ContainerInput = styled.div`
    width: 100%;
    height: auto;
    max-width: 375px;
    min-width: 375px;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    /* border-radius: 1.625rem; */
    /* border: 1px solid #8A92A2; */

    >img{
        width: auto;
        height: auto;

        display: flex;
        margin-top: 0.1875rem;
    }

    >input {
        all: unset;

        width: 100%;
        height: 1.375rem;

        display: flex;
        align-items: flex-start;

        ::placeholder {
            color: #8A92A2;
            font-weight: 400;
            font-size: 0.875rem;
            font-family: "Lato";
            line-height: 1.3125rem;
        }
    }

    @media (max-width: 1024px) {
      max-width: 320px;
      min-width: 320px;
    }

    @media (max-width: 479px) {
      max-width: calc(100% - 52px);
      min-width: auto;
    }

    @media (max-width: 395px) {
        >input {
            ::placeholder{
                font-size: 0.7rem;
            }
        }
    }
`

export const ContainerLastUpdatesAndButton = styled.div`
    width: auto;
    height: auto;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    @media (max-width: 760px) {
      gap: 0;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    @media (max-width: 479px) {
      width: 100%;

        flex-wrap: wrap;
    }
`

export const LastUpdates = styled.div`
    width: 100%;
    height: 3rem;
    max-width: 12.6875rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    
    >p{
        white-space: nowrap;

        text-align: center;
    }

    >button{
        all: unset;

        display: flex;
        align-items: center;

        cursor: pointer;

            >img{
                height: auto;
                width: 1.25rem;
            }
    }

    @media (max-width: 479px) {
        justify-content: center
    }
`

export const ContainerLocalization = styled.div`
    width: auto;
    height: auto;
    max-height: 23.125rem; 

    gap: 1rem;
    /* display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start; */

    //AQUI É O ANTES
    /* display: grid;
    grid-template-columns: auto auto auto auto; */

    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;

    grid-gap: 14.5px;
    
    overflow-x: hidden;
    
    transition: all .3s ease-in-out;

    ::-webkit-scrollbar {
        width: 1px;
        height: 0.0625rem;
    }

    @media (max-width: 900px) {
        width: 100%;
        grid-template-columns: auto;
        max-height: 35rem;
        overflow-y: auto;
    }
`

export const Cardlocalization = styled.div`
    @keyframes animationLoading {
        0% {
            background-color: #f3f3f5;
        }
        50% {
            background-color:rgb(240, 240, 240);
        }
        100% {
            background-color: #f3f3f5;
        }
    }

    padding: 1rem;
    height: auto;
    width: 247px;
    min-height: 146px;
    min-width: 247px;

    gap: 1rem;
    display: flex;
    flex-direction: column;

    border-radius: 1rem;
    background-color: ${props => props.$inativo ? theme.colors.disabled.Fundo_Desabilitado : '#F3F3F5'};

    cursor: pointer;

    animation: ${props => props.loading ? "animationLoading 0.5s infinite" : ""}

    >p{
        text-align: left;
        font-weight: 600;
        font-family: "Lato";
        font-size: 0.5625rem;
        line-height: 0.84375rem;
        letter-spacing: 0.0625em;
        text-transform: uppercase;
    }

    @media (max-width: 575px) {
        min-width: 100%;
    }
`

export const ProductorAndLocal = styled.div`
    width: auto;
    height: auto;

    display: flex;
    justify-content: space-between;
`

export const ContainerImage = styled.div`
    width: 3rem;
    height: 2.5rem;

    display: flex;
    justify-content: center;
    
    >img{
        width: 1rem;
        height: auto;
    }
`

export const ProductorName = styled.div`
    width: auto;
    height: auto;

    display: flex;
    flex-direction: column;

    overflow-x: auto;

   &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 1rem;
    }

    >p{
        text-align: left;
        white-space: nowrap;
    }

    >p:last-child{
      white-space: nowrap;
    }
`

export const ContainerCulture = styled.div`
    width: auto;
    min-height: 27px !important;

    gap: 0.5rem;
    display: flex;
    overflow-x: auto;
    align-items: center;

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 1rem;
    }
`

export const CardCulture = styled.div`
    width: auto;
    height: 24px;
    padding: 0.25rem 0.5rem;

    display: flex;
    align-items: center;

    border-radius: 10rem;
    background-color: ${theme.colors.gray.Cinza_2};

    >p{
        white-space: nowrap;
        text-align: center;
    }
`

export const ButtonShowAll = styled.button`
    all: unset;
    height: auto;
    width: 6.6875rem;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    
    cursor: pointer;
    
    >p{
        cursor: pointer;

        text-align: center;
    }

    >img{
        width: 1rem;
        height: auto;
    }
`

export const Button = styled.button`
    all: unset;

    width: auto;
    height: auto;
    max-width: 230px !important;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1.625rem;
    background-color: #2FBB69;

    position: relative;

    >img{
        height: auto;
        width: 1.25rem;
    }

    >p{
        cursor: pointer;
        
        text-align: center;
    }

    @media (max-width: 350px) {
      padding: 0.75rem 0;
    }
`

export const ButtonAndTooltipWrapper = styled.div`
    position: relative;
    width: auto;
    height: auto;

    @media (max-width: 1024px) {
      >div:nth-of-type(1){
        width: 200px;
      }
    }

    @media (max-width: 760px) {
      >div:nth-of-type(1){
        width: 130px;
      }
    }

    /* @media (max-width: 479px) {
      >div:nth-of-type(1){
        width: 80%;
      }
    } */
`

export const Tooltip = styled.div`
    position: absolute;
    width: 300px;
    max-width: calc(100vw - 32px);
    top: 110%;
    right: 0;
    background-color: #FFFFFF;
    border: 1px solid #E9ECF0;
    border-radius: 14px;
    box-shadow: 0px 12px 32px rgba(29, 33, 41, 0.16);
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    z-index: 10;
`;

export const TooltipOption = styled.button`
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 10px;
    border-radius: 10px;

    color: ${theme.colors.gray.Cinza_2};
    font-family: ${theme.typography.fontFamily.primary};

    svg {
        flex-shrink: 0;
        margin-top: 2px;
        color: ${theme.colors.green.Verde_AgroReceita};
    }

    &:hover {
        background-color: #F4FBF7;
    }
`;

export const TooltipOptionText = styled.span`
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-align: left;
    cursor: pointer;

    b {
        font-size: 13px;
        font-weight: 800;
        color: ${theme.colors.gray.Cinza_2};
        cursor: pointer;
    }

    span {
        font-size: 11.5px;
        font-weight: 400;
        color: ${theme.colors.gray.Cinza_6};
        cursor: pointer;
    }
`;

export const Btn = styled.div`
  width: 100%;
  height: auto;
  min-height: 100px;

  background-color: ${props => props.active ? `${theme.colors.white.Branco}` : '#f3f3f8'};

  border: 1px solid transparent;
  border-radius: 8px;

  padding: 16px 8px;

  box-shadow: 1px 2px 5px 1px rgba(29, 33, 41, 0.4);

  cursor: pointer;
  transition: all 0.3s ease;

  transform: ${props => props.active ? 'scale(1.02)' : 'scale(1)'};

  &:hover {
    transform: scale(1.02);
  }
  
  &:active {
    transform: scale(0.98);
  }

  p {
    cursor: pointer;
  }


`;

export const Title = styled.h1`
  width: 100%;
  font-size: 22px;
  text-align: center;
  margin-bottom: 16px;
`;

export const Text = styled.p`
  width: 100%;
  font-size: 14px;
  text-align: center;
`;

export const Col2 = styled.div`
  width: 45%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 8px;

  @media (max-width: 479px) {
    width: 100%;
  }
`;

export const Row = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;

  padding: 8px;

  li::marker{
    font-size: 12px !important;
  }
`;

export const FlexRowContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;


 @media (max-width: 400px) {
  flex-direction: column;
 }
`;

export const Subtitle = styled.h1`
  width: 100%;
  font-size: 18px;
  text-align: center;
  margin-bottom: 8px;
`;

export const Download = styled.label`
  width: auto;
  font-size: 14px;
  text-align: center;
  color: #589BFF;
  cursor: pointer;

  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

export const Paragraph = styled.p`
  width: 100%;
  font-size: 14px;
`;

export const Col1 = styled.div`
  width: 90%;

  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;

  padding: 8px;

  ol {
    width: 100%;
    margin: 0px;

    text-align: start;

    p {
      font-size: 14px;
      /* margin: 0px; */
    }



  }

  @media only screen and (max-width: 991px) {
    ol {
      width: 90%;
    }
  }
`;

export const Update = styled.div`

  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: -25px;

  .arquivos{
    width: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    /* margin-left: -10px; */

    .btn-update{
      display: flex;
      align-items: center;
      height: 40px;
      background-color: #2fbb69;
      border-radius: 30px;
      border: 1px dashed #2fbb69;
      font-size: 65%;
      color: #FFF;
      margin: 10px 10px 10px 0px ;
      padding: 2px 20px;
      cursor: pointer;
      transition: all 0.3s;
      z-index: 2;
    
      &:hover{
        cursor: pointer;
        background: #2fbb69;
        color: #FFF;
        box-shadow: 0 0 20px 0 #2fbb69;
      }
    }

    .arq-name{
      display: flex;
      align-items: center;
      width: 350px;
      height: 40px;
      background-color: #FFF;
      border-radius: 30px;
      padding: 13px;
      padding-left: 60px;
      margin-left: -55px;
      margin-top: 7px;
      box-shadow: inset 0px 0px 7px 2px #b6b6b6;
      font-family: Lato;
      font-size: 65%;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    img {
      transform: rotate(45deg);
      z-index: 10;
    }

    img:hover{
      cursor: pointer;
    }
  }

  .legenda {
    /* font-size: smaller; */
    font-size: 14px;
    width: 100%;
  }

  .input-wrapper {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: ${props => (props.disabled ? '1px solid #999' : props.outline ? props.red === true ? '1px solid #F10' : `1px solid ${theme.colors.green.Bandeira}` : '1px solid #FFF')};
  border-bottom: ${props => (props.disabled ? '1px solid #999' : props.outline ? props.red === true ? '1px solid #F10' : `1px solid ${theme.colors.green.Bandeira}` : '1px solid #FFF')};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;

export const ButtonSecundary = styled.button`
    all: unset;

    width: auto;
    height: 14px;
    min-width: 70px;
    max-width: 165px;
    padding: 12px 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1.625rem;

    position: relative;

    border: 1px solid ${theme.colors.gray.Cinza_2};
`

export const LoadingRelatorio = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: ${props => props.width ? props.width : '20px'};
  height: ${props => props.height ? props.height : '20px'};
  position: relative;

  background-color: transparent;
  border-top: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-bottom: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;

export const ContainerItemNotFound = styled.div`
  width: 100%;
  height: auto;
  padding: 5rem 0;

  gap: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  >img{
    width: 100%;
    height: auto;
    max-width: 150px;
  }
`;